import React, { useEffect, useState } from "react";
import "../modal.css";
import api from "../api";
import HealthModal from "./Health/csatMessage";
import { Product } from "../constants";
import TravelModal from "./Travel/csatMessage";
import HomeModal from "./Home/csatMessage";
import ServiceModal from "./ServiceBot/csatMessage";
import TermModal from "./Term/csatMessage";
// import InvestmentModal from "./Investment/csatMessage";
import InvestmentModal from "./Investmentv1/csatMessage";
import TermLifeModal from "./TermLife/csatMessage";
import TwoWheelerModal from "./TwoWheeler/csatMessage";

export default function Modal({agentName, empId, GAEvent, closePopup, setCsatDone, customerFeedback, customerQueryResolutionFeedback, closeChat, setModelStatus, clearRoomData, productId, isService ,restartChat,serviceAgentFeedback , option, setOption, newTermUi, askForRatingTicket, ticketRatingDone, ticketInactivityClosed}) {
  let showHideClassName = "";
  const [openModal, setOpenModal] = useState("")
  const [feedback, setFeedback] = useState("");
  const [queryResolvedStatus, setQueryResolvedStatus] = useState("");
  const selectOption = (option) => {
    setOption(option);
  };
  const handleChange = (event) => {
    setFeedback(event);
  };

  useEffect(() => {
    setTimeout(function () {
      setOpenModal("open")
    })
  })
  const handleSubmit = () => {
    console.log(option, feedback)
    closeChat();
    setTimeout(()=>{
      customerFeedback(option, feedback);
    },100)
    console.log("handleSubmit");
    setCsatDone();
  };
  const handleSubmitService = () => {
    console.log(option, feedback)
    // closeChat();
    setTimeout(() => {
      customerFeedback(option, feedback);
    }, 100)
    console.log("handleSubmit");
    setCsatDone();
  };

  const handleTicketSubmit = (csatOption) => {
    closeChat();
    setTimeout(() => {
      customerFeedback(csatOption, feedback);
    }, 100)
  };
  const handleQueryResolvedSubmit = () => {
    if (queryResolvedStatus) {
      closeChat();
      setTimeout(() => {
        customerQueryResolutionFeedback(queryResolvedStatus);
      }, 100)
      setCsatDone();
    }
  };

  const handleClosePop = () => {
    setModelStatus(false);
    closePopup();
  }
  const CloseChat = (e) => {
    // e.preventDefault();
    clearRoomData()
    setModelStatus(false);
    console.log("minimizing ini");
    if (window && window.parent) {
      console.log("minimizing start");
      setTimeout(function () {
        // window.parent.postMessage({ message: 'Box minimize.', minimize: true, closeChat: true }, '*');
        if(productId === Product.Investment && !isService){
          window.parent.postMessage({ message: 'Box minimize.', investmentChatMinimize: true , closeChat: true }, '*');
        }else{
          window.parent.postMessage({ message: 'Box minimize.', minimize: true ,  closeChat: true }, '*');
        }
      }, 100)
    } else {
      console.log("minimizing not  start");
    }
    if (window.parent?.ReactNativeWebView) {
      setTimeout(function () {
        window.parent.ReactNativeWebView.postMessage('close_webview');
      }, 300)
    }
    if (window?.ReactNativeWebView) {
      setTimeout(function () {
        window?.ReactNativeWebView.postMessage('close_webview');
      }, 300)
    }
  }



  return (
    <>
      {productId === Product.Health && !isService ?
        <HealthModal
          CloseChat={CloseChat}
          handleSubmit={handleSubmit}
          handleClosePop={handleClosePop}
          selectOption={selectOption}
          openModal={openModal}
          option={option} />
        : null}
      {productId === Product.Travel && !isService ?
        <TravelModal
          CloseChat={CloseChat}
          handleSubmit={handleSubmit}
          handleClosePop={handleClosePop}
          selectOption={selectOption}
          openModal={openModal}
          option={option} />
        : null}
      {productId === Product.Investment && !isService ?
        <InvestmentModal
          CloseChat={CloseChat}
          handleSubmit={handleSubmit}
          handleClosePop={handleClosePop}
          selectOption={selectOption}
          openModal={openModal}
          option={option} />
        : null}
      {productId === Product.Home && !isService ?
        <HomeModal
          CloseChat={CloseChat}
          handleSubmit={handleSubmit}
          handleClosePop={handleClosePop}
          selectOption={selectOption}
          openModal={openModal}
          option={option}
        />
        : null}
      {productId === Product.Term && !isService && !newTermUi ?
        <TermModal
          CloseChat={CloseChat}
          handleSubmit={handleSubmit}
          handleClosePop={handleClosePop}
          selectOption={selectOption}
          openModal={openModal}
          option={option}
        />
        : null}
      {productId === Product.Term && !isService && newTermUi ?
        <TermLifeModal
          CloseChat={CloseChat}
          handleSubmit={handleSubmit}
          handleClosePop={handleClosePop}
          selectOption={selectOption}
          openModal={openModal}
          option={option}
        />
        : null}
      {isService ?
        <ServiceModal
          CloseChat={CloseChat}
          handleSubmit={handleSubmit}
          handleClosePop={handleClosePop}
          selectOption={selectOption}
          setFeedback={setFeedback}
          openModal={openModal}
          option={option}
          restartChat={restartChat}
          serviceAgentFeedback={serviceAgentFeedback}
          agentName={agentName}
          empId={empId}
          GAEvent={GAEvent}
          askForRatingTicket={askForRatingTicket}
          ticketRatingDone={ticketRatingDone}
          ticketInactivityClosed={ticketInactivityClosed}
          handleTicketSubmit={handleTicketSubmit}
          setQueryResolvedStatus={setQueryResolvedStatus}
          handleQueryResolvedSubmit={handleQueryResolvedSubmit}
          handleSubmitService={handleSubmitService}
        />
        : null}
      {productId === Product.Twowheeler && !isService ?
        <TwoWheelerModal
          CloseChat={CloseChat}
          handleSubmit={handleSubmit}
          handleClosePop={handleClosePop}
          selectOption={selectOption}
          openModal={openModal}
          option={option} />
      : null}
    </>
  );
}
